import { render, staticRenderFns } from "./VisitSecuItemList.vue?vue&type=template&id=f89bc566&scoped=true"
import script from "./VisitSecuItemList.vue?vue&type=script&lang=js"
export * from "./VisitSecuItemList.vue?vue&type=script&lang=js"
import style0 from "./VisitSecuItemList.vue?vue&type=style&index=0&id=f89bc566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89bc566",
  null
  
)

export default component.exports